import { map, filter, pluck } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { roomTypes } from '../../../actions/room/roomTypes'
import trackActions from '../../../actions/tracks'
import { mediaType } from '@bt-react/constants'

const unpublishScreen$ = (actions$) => actions$.pipe(
  ofType(roomTypes.SET_MEDIA_TYPE_STATE),
  pluck('payload'),
  filter(payload => payload !== mediaType.SCREENSHARE),
  map(() => trackActions.unpublishScreen())
)

export default unpublishScreen$
